import React from 'react';
import { useNotifications } from './contexts/NotificationsContext';
import * as styles from './serializers.module.scss';
import { clsx } from './utils/utils';

const GenericLinkSerializer = (props: {
  mark: {
    url: string;
  };
  children: React.ReactNode;
}): React.ReactElement => {
  return (
    <a href={props.mark.url} target="_blank" rel="noopener">
      {props.children}
    </a>
  );
};

const ItemGridSerializer = (props: {
  node: {
    withColumnLayout?: boolean;
  } & (
    | {
        items?: never;
        companyResults: Array<{
          number: string;
          subtitle: string;
        }>;
      }
    | {
        items: Array<string>;
        companyResults?: never;
      }
  );
}): React.ReactElement => {
  const companyResults =
    props.node.companyResults &&
    props.node.companyResults.length > 0 &&
    props.node.companyResults.map(result => `${result.number} ${result.subtitle.toLowerCase()}`);

  return (
    <div
      className={clsx(
        styles.itemGridContainer,
        props.node.withColumnLayout && styles.withColumnLayout,
      )}
    >
      {(companyResults ? companyResults : props.node.items ?? []).map((item, i) => (
        <span key={i} className={styles.itemGrid}>
          {item}
        </span>
      ))}
    </div>
  );
};

const LinkToDownloadFileSerializer = (props: {
  children: any;
  serializerContext: string;
}): React.ReactElement => {
  const { clearNotification } = useNotifications();

  const fileUrl = props.serializerContext;
  return (
    <a href={fileUrl} download onClick={clearNotification}>
      {props.children}
    </a>
  );
};

export const getSerializers = (context?: any) => ({
  marks: {
    genericLink: props => <GenericLinkSerializer {...props} serializerContext={context} />,
    linkToDownloadFile: props => (
      <LinkToDownloadFileSerializer {...props} serializerContext={context} />
    ),
  },
  types: {
    itemGrid: props => <ItemGridSerializer {...props} serializerContext={context} />,
  },
});

const serializers = getSerializers();

export default serializers;
